<div class="max-h-[70vh] p-8 relative overflow-y-auto 3xl:p-12">
    <p theme border-b class="text-2xl font-bold border-b-[4px] !mb-4 block">
      <span class="block !mb-2">Preview AI Descriptions</span>
      <mat-icon mat-icon-button mat-dialog-close
        class="cursor-pointer absolute right-6 top-6 text-gray-400">close</mat-icon>
    </p>

    <div *ngFor="let desc of descList; let i = index" class="flex flex-col gap-1 !mb-3">
        <b>Version {{i + 1}}</b>
        <div class="text-sm border-2 border-gray-200 p-2 rounded-lg border-dashed cursor-pointer" (click)="selectDescription(i)" 
        [class.!border-solid]="selectedIndex==i" [class.!border-blue-400]="selectedIndex==i" [class.!border-[3px]]="selectedIndex==i">{{desc}}</div>
    </div>

    <ig-button theme cls="w-[120px]" class="w-[120px] block mt-6" [disabled]="selectedIndex<0" (trigger)="submit($event)">Select</ig-button>
</div>